import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import styled from "styled-components";
import { getThousandComma } from "../../../../Api/ApiCommon";
import { useApi } from "../../../../hooks/useApi";
import LineBox from "../../../DefaultStyles/LineBox";
import Chart from "react-apexcharts";
import { ISeries } from "../PayBoard/PayHistorySection";
import DashBoardToggleBtn from "../DashBoardToggleBtn";
import useIsMobile from "../../../../hooks/useIsMobile";

export interface IndateSectionProps {
  filter: {
    startDate: string;
    endDate: string;
    isAccum: boolean;
  };
  setFilter: any;
}

interface SAxixTitle {
  isX?: boolean;
}

interface SDashBoardViewDate {
  isMobile?: boolean;
}

interface SChartContainer {
  sHeight?: number;
}

export default function IndateSection({
  filter,
  setFilter,
}: IndateSectionProps) {
  const isMobile = useIsMobile();

  const { response } = useApi({
    method: "get",
    url:
      filter.startDate !== "" && filter.endDate !== ""
        ? `dash/total?type=user&subtype=indate&startdate=${dayjs(
            filter.startDate
          )
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&enddate=${dayjs(filter.endDate)
            .add(1, "day")
            ?.format("YYYY-MM-DD")}&filter=day`
        : undefined,
  });

  const [series, setSeries] = useState<ISeries[]>([
    {
      name: "",
      data: [0, 0, 0, 0],
    },
  ]);
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    let series: any[] = [];
    let date: string[] = [];

    if (response?.status === 200) {
      for (let i = 0; i < response?.data.length; i++) {
        const element = response?.data[i];

        series.push(
          Number(
            (filter.isAccum ? element?.data?.total : element?.data?.count) ?? 0
          )
        );

        date.push(dayjs(element.date).add(-1, "day").format("M/DD (dd)"));
      }

      setSeries([
        {
          name: "가입자",
          data: series.reverse(),
        },
      ]);

      setDate(date.reverse());
    }
  }, [response, filter]);

  return (
    <>
      <DashBoardSectionTitleContainer>
        <DashBoardSectionTitle>가입자 추이</DashBoardSectionTitle>

        <DashBoardToggleBtn
          btnTextArray={["일별", "누적"]}
          filter={filter}
          setFilter={setFilter}
        />
      </DashBoardSectionTitleContainer>

      <LineBox boxPadding={"28px 32px"}>
        <DashBoardViewDate isMobile={isMobile}>
          조회 기간 : {filter.startDate} ~ {filter.endDate}
        </DashBoardViewDate>

        <ChartContainer>
          <AxixTitle>명</AxixTitle>
          <Chart
            type="line"
            height={300}
            series={series}
            options={{
              chart: {
                height: 350,
                type: "line",
                zoom: {
                  enabled: false,
                },
                toolbar: {
                  show: false,
                },
              },
              dataLabels: {
                enabled: true,
                offsetY: -5,
                style: {
                  fontWeight: 500,
                  colors: ["#ffffff"],
                },
                formatter: (val) => {
                  return getThousandComma(val);
                },
                background: {
                  dropShadow: {
                    enabled: false,
                  },
                  borderColor: "#ffffff",
                  foreColor: "#22222",
                  padding: 0,
                },
              },
              stroke: {
                curve: "smooth",
              },
              xaxis: {
                categories: date,
              },
              yaxis: {
                labels: {
                  offsetX: -8,
                  formatter: (value) => {
                    return getThousandComma(value ?? 0);
                  },
                },
              },
              tooltip: {
                y: {
                  formatter: (value) => getThousandComma(value ?? 0) + "명",
                },
              },
            }}
          />

          <AxixTitle isX>날짜</AxixTitle>
        </ChartContainer>
      </LineBox>
    </>
  );
}

export const ChartContainer = styled.div<SChartContainer>`
  width: 100%;
  position: relative;
  height: ${({ sHeight }) => sHeight ?? 310}px;
`;

export const AxixTitle = styled.span<SAxixTitle>`
  position: absolute;
  left: ${({ isX }) => (isX ? "unset" : "20px")};
  right: ${({ isX }) => (isX ? "10px" : "unset")};
  bottom: ${({ isX }) => (isX ? "-5px" : "unset")};
  font-size: 11px;
  font-weight: 900;
  color: #373d3f;
`;

export const DashBoardSectionTitleContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
`;

export const DashBoardSectionTitle = styled.div`
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  color: ${({ theme }) => theme.color.textColor};
`;

export const DashBoardViewDate = styled.div<SDashBoardViewDate>`
  font-size: ${({ isMobile }) => (isMobile ? 9 : 13)}px !important;
  line-height: 19.5px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray600};
  margin-bottom: 20px;
`;
